module.exports = __webpack_public_path__ + "img/mazer-3.4edd0bb3.jpg";